import React from 'react'
import Index from '../_components/TrainModule/Index'

function TrainModule() {
  return (
    <Index />
  )
}

export default TrainModule